package top.wcpe.allincore.dsl.ir.model

import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedMap
import kotlin.jvm.JvmStatic

/**
 * v2 params 声明表。
 */
class UiParams(entries: Map<String, UiParam>) {

    // val 属性生成 getEntries()（原 Lombok @Getter），保序不可变。
    val entries: Map<String, UiParam>

    init {
        requireNotNull(entries) { "entries" }
        val copied = LinkedHashMap<String, UiParam>(entries.size)
        for (entry in entries.entries) {
            val name = requireNotNull(entry.key) { "params key" }
            val param = requireNotNull(entry.value) { "params value" }
            copied[name] = param
        }
        // 复刻原 Java Collections.unmodifiableMap 语义：保序 + Java 侧 put/remove 抛 UnsupportedOperationException。
        this.entries = ReadOnlyOrderedMap(copied)
    }

    fun isEmpty(): Boolean = entries.isEmpty()

    // 复刻 Lombok @EqualsAndHashCode 默认行为（字段 entries + canEqual）。
    override fun equals(other: Any?): Boolean {
        if (other === this) return true
        if (other !is UiParams) return false
        if (!other.canEqual(this)) return false
        return entries == other.entries
    }

    private fun canEqual(other: Any?): Boolean = other is UiParams

    // 逐位复刻 Lombok hashCode（PRIME=59、种子 1、null=43）。
    override fun hashCode(): Int {
        val prime = 59
        var result = 1
        result = result * prime + entries.hashCode()
        return result
    }

    // 复刻 Lombok @ToString 默认格式。
    override fun toString(): String = "UiParams(entries=" + entries + ")"

    companion object {
        private val EMPTY = UiParams(emptyMap())

        @JvmStatic
        fun empty(): UiParams = EMPTY
    }
}
